/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineSharedCompanies200,
  GetApiV1ClassroomdisciplineSharedCompanies401,
  GetApiV1ClassroomdisciplineSharedCompaniesQueryParams,
  GetApiV1ClassroomdisciplineSharedCompaniesQueryResponse,
} from "../../types/classPlanningSharedController/GetApiV1ClassroomdisciplineSharedCompanies.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1ClassroomdisciplineSharedCompaniesQueryParamsSchema = z
  .object({
    Search: z.optional(z.string()),
    Take: z.optional(z.coerce.number().int()),
    Culture: z.optional(z.string()),
    CourseId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1ClassroomdisciplineSharedCompaniesQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineSharedCompanies200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedCompanies200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineSharedCompanies401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineSharedCompanies401>;

export const getApiV1ClassroomdisciplineSharedCompaniesQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineSharedCompanies200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedCompaniesQueryResponse>;
